// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3tdCq","requiredAsterisk":"Info_requiredAsterisk__1Z-X_"};